import { Filters } from '~/app/features/Gallery/components/Filters'
import { usePersonalizationConfig } from '~/app/features/Gallery/hooks/usePersonalizationConfig'
import { PersonalizationCard } from '@vp/design-personalization-widget'

export const FiltersSidebar = () => {
  const { isEnabled, mode, imageCopyKey } = usePersonalizationConfig()
  const showPersonalization = isEnabled && mode === 'sidebar'

  return (
    <nav className="left-nav">
      {showPersonalization && <PersonalizationCard />}
      <Filters showAlternativeHeader={showPersonalization} showColorFirst={showPersonalization && imageCopyKey !== 'Photo'} />
    </nav>
  )
}

FiltersSidebar.displayName = 'FiltersSidebar'
